import { Link, SectionMessage, Text } from '@billy/design-system'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { useOrgUsesReceiptsOnly } from '../../../../hooks/useOrgUsesReceiptsOnly'

export const AUTO_FORWARD_SIMPLIFICATION_LEARN_MORE_URL =
  'https://help.shine.fr/shine-facture/fr/articles/15885445-l-auto-validation-evolue-et-devient-le-partage-automatique'

export const AutoForwardSimplificationBanner = (): ReactElement | null => {
  const { t } = useTranslation()
  const orgUsesReceiptsOnly = useOrgUsesReceiptsOnly()

  if (!orgUsesReceiptsOnly) {
    return null
  }

  return (
    <SectionMessage variant="info">
      {t('receipts.auto_forward_simplification.banner.message')}{' '}
      <Text as="span" inherit weight="bold">
        <Link href={AUTO_FORWARD_SIMPLIFICATION_LEARN_MORE_URL} rel="noopener noreferrer" target="_blank">
          {t('receipts.auto_forward_simplification.banner.learn_more')}
        </Link>
      </Text>
    </SectionMessage>
  )
}
